<template>
  <div class="dispatch-page">
    <div v-bind:class="{
        'reservation-panel': true,
        hide: false
      }">

      <div v-if="rsvp !== null && !rsvp.isPackage">
        <reservation-details :rsvp="rsvp"></reservation-details>
      </div>

      <div v-if="rsvp !== null && rsvp.isPackage">
        <package-details :package="rsvp"></package-details>
      </div>

      <div v-if="rsvp === null" class="no-rsvp">
        <div class="no-rsvp-content">
          <div class="icon"><i class="fas fa-info-circle fa-4x"></i></div>
          <div class="title">{{ $t('dispatch.mapDetails.emptyTitle') }}</div>
          <div class="content" v-html="$t('dispatch.mapDetails.emptyContent')"></div>
        </div>
      </div>
    </div>

    <div class="map">
      <!-- <dispatch-map v-if="$route.name === 'DispatchMapDetails'"></dispatch-map> -->
      <dispatch-map2></dispatch-map2>
    </div>

    <dispatch-modal></dispatch-modal>
    <dispatch-notification></dispatch-notification>
    <dispatch-schedule></dispatch-schedule>
  </div>
</template>

<script>
// import DispatchMap from './Map'
import DispatchMap2 from './Map2'
import DispatchModal from './DispatchModal'
import DispatchNotification from './DispatchNotification'
import DispatchSchedule from './DispatchSchedule'
import ReservationDetails from './ReservationDetails'
import PackageDetails from './PackageDetails'

export default {
  name: 'dispatch-map-details',
  components: { DispatchMap2, DispatchModal, DispatchNotification, DispatchSchedule, ReservationDetails, PackageDetails },
  computed: {
    rsvp () {
      let self = this
      if (self.$store.state.dispatch.rsvpInMap.id === null) {
        return null
      }
      return self.$store.state.dispatch.rsvpInMap
    }
  },
  mounted () {
    this.$store.commit('sideMenu/hideMenuButton')
  },
  destroyed () {
    this.$store.commit('sideMenu/showMenuButton')
  }
}
</script>

<style lang="scss" scoped>
$reservation-panel-width: 500px;

.map{
  position: fixed;
  top: 0;
  left: $reservation-panel-width;
  z-index: 1;
  height: 100%;
  width: calc(100% - #{$reservation-panel-width});
}
.reservation-panel {
  position: fixed;
  top: 0; left: 0;
  z-index: 2;
  background-color: #F4F8F9;
  width: $reservation-panel-width;
  height: 100%;
  box-shadow: 2px 0  4px rgba(0,0,0,0.2);
  transition: all 250ms;
  overflow-x: auto;

  &.hide{
    left: -#{$reservation-panel-width};
  }
}

.no-rsvp{
  position: relative;
  text-align: center;
  color: #777;
  height: 100%;
  width: 100%;

  & .no-rsvp-content{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 20px;
  }

  & .icon {
    color: #F25E0D;
  }

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 5px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DispatchMapDetails.vue